<template>
    <div class="payTop">
        <div class="main">
            <span class="title">{{ title }}</span>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            title:{
                type:String
            }
        },
    };
</script>
<style scoped>
    .payTop{
        width: 100%;
        height: 40px;
        padding: 8px 34px 7px 34px;
        background: #313131;
    }
    .payTop .main {
        width: 100%;
        height: 100%;
    }
    .payTop .main > span{
        color:#fff;
        font-size: 18px;
    }
</style>